<template>
    <span :class="class">{{ formattedEuro }}</span>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            required: true,
        },
        digits: {
            type: Number,
            required: false,
            default: 2
        },
        class: {
            type: String,
            required: false,
        }
    },
    computed: {
        formattedEuro() {
            const v = this.value;
            const hasFractionalPart = v % 1 !== 0;
            return v.toLocaleString('nl-BE', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: hasFractionalPart ? this.digits : 0,
                maximumFractionDigits: this.digits,
            });
        },
    },
};
</script>
